export const MyCardHolder = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M31.4751 15.1949C31.4751 9.5749 27.583 4.6449 21.9934 3.1449C19.7161 1.2049 16.7349 0.0249023 13.4639 0.0249023C6.33195 0.0249023 0.524902 5.6349 0.524902 12.5249V13.1149C0.524902 17.4449 2.81253 21.2649 6.29054 23.5149C8.09166 28.5849 12.9567 31.9749 18.5257 31.9749C21.9727 31.9749 25.223 30.6749 27.6865 28.3149C30.1294 25.9549 31.4751 22.8149 31.4751 19.4649V18.8849C31.4751 18.3749 31.444 17.8649 31.3716 17.3249C31.4337 16.8249 31.4751 16.3149 31.4751 15.7949V15.1949ZM29.4049 15.1949V15.7949C29.4049 18.5949 28.2766 21.2349 26.227 23.2149C24.1775 25.1949 21.4448 26.2849 18.5361 26.2849C17.1593 26.2849 15.824 26.0349 14.5715 25.5649C21.1963 25.0249 26.4237 19.6549 26.4237 13.1149V12.5249C26.4237 10.4149 25.8751 8.4349 24.9124 6.6849C27.6762 8.6249 29.4152 11.7449 29.4152 15.1949H29.4049ZM2.59515 13.1149V12.5249C2.59515 6.7349 7.47058 2.0249 13.4639 2.0249C19.4573 2.0249 24.3327 6.7349 24.3327 12.5249V13.1149C24.3327 18.9049 19.4573 23.6149 13.4639 23.6149C7.47058 23.6149 2.59515 18.9049 2.59515 13.1149ZM26.227 26.8949C24.1671 28.8749 21.4344 29.9649 18.5257 29.9649C14.644 29.9649 11.1556 28.0049 9.21994 24.9049C9.45802 24.9849 9.6961 25.0549 9.93418 25.1249C12.3046 27.1549 15.3375 28.2749 18.5257 28.2749C21.9934 28.2749 25.2437 26.9749 27.6865 24.6149C27.935 24.3749 28.1731 24.1149 28.4008 23.8549C27.8729 24.9649 27.1483 25.9949 26.227 26.8849V26.8949Z"
        fill="#424242"
      />
      <path
        d="M8.41274 19.8649H8.39204C7.82272 19.8649 7.36726 19.4049 7.37761 18.8449C7.40867 17.3049 8.0608 15.8249 9.17873 14.7649C10.3588 13.6549 11.8804 13.0449 13.4745 13.0449C16.7765 13.0449 19.5093 15.6449 19.561 18.8449C19.561 19.3949 19.1159 19.8549 18.5466 19.8649H18.5259C17.9669 19.8649 17.5011 19.4249 17.4908 18.8849C17.4494 16.7749 15.6483 15.0549 13.4745 15.0549C12.429 15.0549 11.4146 15.4649 10.6176 16.2149C9.88261 16.9049 9.45821 17.8749 9.43751 18.8949C9.43751 19.4449 8.96135 19.8749 8.40239 19.8749L8.41274 19.8649Z"
        fill="url(#paint0_linear_280_53114)"
      />
      <path
        d="M13.474 12.2349C11.4762 12.2349 9.85107 10.6649 9.85107 8.73486C9.85107 6.80486 11.4762 5.23486 13.474 5.23486C15.4718 5.23486 17.0969 6.80486 17.0969 8.73486C17.0969 10.6649 15.4718 12.2349 13.474 12.2349ZM13.474 7.22486C12.6149 7.22486 11.9213 7.89486 11.9213 8.72486C11.9213 9.55486 12.6149 10.2249 13.474 10.2249C14.3332 10.2249 15.0267 9.55486 15.0267 8.72486C15.0267 7.89486 14.3332 7.22486 13.474 7.22486Z"
        fill="url(#paint1_linear_280_53114)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_280_53114"
          x1="13.4692"
          y1="13.0449"
          x2="13.4692"
          y2="19.8749"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFBE66" />
          <stop offset="0.34" stop-color="#EDB05D" />
          <stop offset="1" stop-color="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_280_53114"
          x1="13.474"
          y1="5.23486"
          x2="13.474"
          y2="12.2349"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFBE66" />
          <stop offset="0.34" stop-color="#EDB05D" />
          <stop offset="1" stop-color="#CA7701" />
        </linearGradient>
      </defs>
    </svg>
  );
};
